import { useEffect, useState } from 'react';
import { css } from '@emotion/react'
import styled from '@emotion/styled'
import EditForm from '../../utils/utilities/EditForm';

import { Grid } from '@mui/material';

import { fields, initialValues, schema, additionalState, values_config, values_initialValues } from './config';


const EditInventoryValue = ({dialog = false, category = "values"}) => {

  const [formFields, setFormFields] = useState([...values_config.map(field => ({...field}))]);
  const [initValues, setInitValues] = useState(values_initialValues);

  useEffect(() => {
    if (category === "values") {
      setFormFields([...values_config.map(field => ({...field}))]);
      setInitValues(values_initialValues);
    } else {
      setFormFields([...fields.map(field => ({...field}))]);
      setInitValues(initialValues);
    }
  }, [category]);

  return (
    <EditForm title={"Inventory Value"} initialValues={initValues} fields={formFields} schema={schema} url={`inventory_values`} additionalState={additionalState} dialog={dialog} redirect={`/settings/inventory/${category}`}>
      
     </EditForm>
  );
}

export default EditInventoryValue;